export const EMAIL_CAPTURE_PROMPT = 'EMAIL_CAPTURE_PROMPT';